"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swiper_1 = require("swiper");
var react_2 = require("swiper/react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var navigation_1 = require("next/navigation");
var common_hooks_1 = require("@l2p/common-hooks");
var ui_components_1 = require("@l2p/ui-components");
var SpecialOffers = function (_a) {
    var _b, _c;
    var _d = _a.offers, offers = _d === void 0 ? [] : _d, _e = _a.desktopSliderCardsCount, desktopSliderCardsCount = _e === void 0 ? 4 : _e, _f = _a.sliderStartWith, sliderStartWith = _f === void 0 ? 2 : _f;
    var slider = (0, react_1.useRef)(null);
    var brand = (0, swr_hooks_1.useBrand)().brand;
    var config = (0, swr_hooks_1.useConfig)();
    var hasInfoButton = (_b = config === null || config === void 0 ? void 0 : config.specialOffers) === null || _b === void 0 ? void 0 : _b.hasInfoButton;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var liveChatVisibility = (0, common_hooks_1.useLiveChatVisibility)();
    var _g = react_1.default.useState(null), infoModal = _g[0], setInfoModal = _g[1];
    var defaultOffers = offers.length
        ? offers
        : [
            {
                title: t.raw('specialOfferTitle5'),
                text: t('specialOfferText5'),
                className: 'card-5',
                onClick: function () { return liveChatVisibility === null || liveChatVisibility === void 0 ? void 0 : liveChatVisibility(); },
            },
            {
                title: t.raw('specialOfferTitle6'),
                text: t('specialOfferText6'),
                className: 'card-6',
                onClick: function () { return liveChatVisibility === null || liveChatVisibility === void 0 ? void 0 : liveChatVisibility(); },
            },
            {
                title: t.raw('specialOfferTitle7'),
                text: t('specialOfferText7', { brand: brand }),
                className: 'card-7',
                onClick: function () { return router.push(generateUrlWithLang('/promotions')); },
            },
            {
                title: t.raw('specialOfferTitle1'),
                text: t('specialOfferText1'),
                className: 'card-1',
                onClick: function () { return router.push(generateUrlWithLang('/promotions')); },
            },
            {
                title: t.raw('specialOfferTitle2'),
                text: t('specialOfferText2', { brand: brand }),
                className: 'card-2',
                onClick: function () { return router.push(generateUrlWithLang('/promotions')); },
            },
            {
                title: t.raw('specialOfferTitle3'),
                text: t('specialOfferText3', { brand: brand }),
                className: 'card-3',
                onClick: function () { return router.push(generateUrlWithLang('/vip')); },
            },
            {
                title: t.raw('specialOfferTitle4'),
                text: t('specialOfferText4', { brand: brand }),
                className: 'card-4',
                onClick: function () { return router.push(generateUrlWithLang('/promotions')); },
            },
        ];
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h1", null, t('specialOffersHeader', {
                    brand: brand,
                })))),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.offers, " special-offers") },
            react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                    slider.current = swiper;
                }, className: styles_module_scss_1.default.swiper, modules: [swiper_1.Pagination, swiper_1.Navigation], loop: true, spaceBetween: 20, slidesPerView: breakpoints.mobile && ((_c = Object.keys(breakpoints)) === null || _c === void 0 ? void 0 : _c.length) > 0
                    ? 1
                    : desktopSliderCardsCount, pagination: { clickable: true }, navigation: true, initialSlide: sliderStartWith, autoplay: false, loopAdditionalSlides: (defaultOffers === null || defaultOffers === void 0 ? void 0 : defaultOffers.length) || 0 }, defaultOffers.map(function (c) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "onVariousTheme_".concat(c.title) },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.offer, " ").concat(styles_module_scss_1.default[c.className]), onClick: c === null || c === void 0 ? void 0 : c.onClick },
                    hasInfoButton && (react_1.default.createElement("button", { className: styles_module_scss_1.default.infoButton, onClick: function (event) {
                            event.stopPropagation();
                            setInfoModal({
                                title: c.title,
                                text: c.text,
                            });
                        } },
                        react_1.default.createElement("img", { src: "/img/icons/infoRound.svg", alt: "info" }))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.borderGradient }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.name, dangerouslySetInnerHTML: {
                            __html: c.title,
                        } }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.count }, c.text),
                    c.button && react_1.default.createElement("div", { className: styles_module_scss_1.default.button }, c.button)))); }))),
        infoModal && (react_1.default.createElement(ui_components_1.Modal, { width: "335px", height: "232px", onClose: function () { return setInfoModal(null); } },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.modalContent },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.modalTitle }, infoModal.title.replace(/<[^>]+>/g, '')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.modalText }, infoModal.text),
                react_1.default.createElement("button", { className: styles_module_scss_1.default.modalButton, onClick: function () { return setInfoModal(null); } }, t('ok')))))));
};
exports.default = SpecialOffers;
